<template>
  <div id="main-wrapper" class="columns">
    <div
      id="sidebar"
      class="column is-narrow px-6 py-6 has-background-white-ter"
    >
      <Sidebar />
    </div>
    <div id="main-content" class="column">
      <section class="section">
        <div class="container">
          <slot></slot>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/layout/Sidebar";

export default {
  components: { Sidebar }
};
</script>

<style lang="scss" scoped>
#main-wrapper {
  min-height: 100vh;
}

#main-content {
  padding: 1rem 6rem;
}
</style>
